import type { IVehicle } from '@makemydeal/dr-platform-types';

import { isValidVehicle } from './isValidVehicle';

export const isDealVehicleInStock = (vehicle?: IVehicle): vehicle is IVehicle => !!(vehicle?.stockNumber && vehicle.vin);

export const toValidatableVehicle = (vehicle: IVehicle): IVehicle => ({
    ...vehicle,
    condition: vehicle.condition?.toLowerCase()
});

export const isSameVehicle = (a: IVehicle | undefined, b: IVehicle | undefined): boolean =>
    !!a && !!b && a.vin === b.vin && a.stockNumber === b.stockNumber;

export const findAutoExpandRow = (rows: IVehicle[], dealVehicle?: IVehicle): IVehicle | undefined => {
    const [firstRow] = rows;
    const isUnpriced = !!dealVehicle && !isValidVehicle(toValidatableVehicle(dealVehicle));

    return isUnpriced && isDealVehicleInStock(dealVehicle) && isSameVehicle(firstRow, dealVehicle) && !isValidVehicle(firstRow)
        ? firstRow
        : undefined;
};
